export default {
  CREATE_0: 0, // 新增
  EDIT_1: 1, // 编辑
  VIEW_2: 2 // 查看
};
